<template>
  <modal
    name="share-modal"
    classes="v--modal-share"
    height="auto"
    adaptive
    @before-open="beforeOpen"
  >
    <div class="modal-header">
      <div class="header">
        Share the retro love
        <p class="close-button">
          <button @click="$modal.hide('share-modal')">
            <i class="fas fa-times"></i>
          </button>
        </p>
      </div>
    </div>

    <div class="modal-content">
      <div class="modal-title">
        Share the game with friends and earn points. The better they play the
        more you earn.
      </div>

      <div class="share-box">
        <ShareBox :score="totalScore" :currentUser="currentUser" />
      </div>
    </div>
  </modal>
</template>

<script>
import ShareBox from "@/components/shared/ShareBox";
export default {
  components: { ShareBox: ShareBox },
  data: () => {
    return {
      totalScore: undefined,
      currentUser: undefined
    };
  },
  methods: {
    beforeOpen(event) {
      this.totalScore = event.params.totalScore;
      this.currentUser = event.params.currentUser;
    }
  }
};
</script>

<style lang="scss" scoped>
.share-box {
  a {
    margin: 0 5px;
  }
  background: #312a58;
  border-radius: 20px;
  padding: 20px 0px 5px;
}
</style>
